<script>
    import { mapActions } from 'vuex';

    export default {
        data() {
        },

        async created() {
        },

        methods: {
            ...mapActions('me', {
                $_downloadProfilePDF: 'downloadProfilePDF',
            }),

            downloadProfilePDF() {
                this.$_downloadProfilePDF().then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'myProfile.pdf');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            },
        },
    };
</script>
